import React, { useEffect, useContext, useState } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

//views
import RelatorioDemonstrativoAnual from "./RelatoriosSistema/RelatorioDemonstrativoAnual";
import RelatorioDetalhamentoContrato from "./RelatoriosSistema/RelatorioDetalhamentoContrato";
import RelatorioMidiaxVendas from "./RelatoriosSistema/RelatorioMidiaxVendas";
import RelatorioVendasByCliente from "./RelatoriosSistema/RelatorioVendasByCliente";
import RelatorioTelegramaRecebiveis from "./RelatoriosSistema/RelatorioTelegramaRecebiveis";
import RelatorioVendasByAtendente from "./RelatoriosSistema/RelatorioVendasByAtendente";
import RelatorioResumoVendaPorTipoPagamento from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioResumoVendaPorTipoPagamento";
import RelatorioVendabyPacotes from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioVendabyPacotes";
import RelatorioVendabyProdutos from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioVendabyProdutos";
import RelatorioVendabyServicos from "beaktMatriz/views/Relatorios/RelatoriosSistema/RelatorioVendabyServicos";
import RelatorioSaldoEstoque from "./RelatoriosSistema/RelatorioSaldoEstoque";
import RelatorioMovimentoEstoque from "./RelatoriosSistema/RelatorioMovimentoEstoque";

//services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

export default function RelatoriosSistemaList() {

  const session = useContext(SessionContext);

  const list_relatorios = [
    {
      tipo: "Vendas",
      relatorios: [
        { codigo: "relPermissao", codigoPermissao: "relResumoVendasPorTipoPagamento", title: "Vendas Por Tipo Pagamento", description: "Relatório detalhado das vendas por tipos de pagamento", component: (<RelatorioResumoVendaPorTipoPagamento></RelatorioResumoVendaPorTipoPagamento>) },
        { codigo: "relPermissao", codigoPermissao: "relPagamentosByPacotes", title: "Vendas por Pacotes", description: "Relatório detalhado das vendas por pacotes.", component: (<RelatorioVendabyPacotes></RelatorioVendabyPacotes>) },
        { codigo: "relPermissao", codigoPermissao: "relPagamentosByProdutos", title: "Vendas por Produtos", description: "Relatório detalhado das vendas por produtos.", component: (<RelatorioVendabyProdutos></RelatorioVendabyProdutos>) },
        { codigo: "relPermissao", codigoPermissao: "relPagamentosByServicos", title: "Vendas por Serviços", description: "Relatório detalhado das vendas por serviços.", component: (<RelatorioVendabyServicos></RelatorioVendabyServicos>) },
        { codigo: "relPermissao", codigoPermissao: "relVendasByAtendente", title: "Vendas por Atendente", description: "Relatório contendo dados de vendas feitas por atendente", component: (<RelatorioVendasByAtendente></RelatorioVendasByAtendente>) },
        { codigo: "relPermissao", codigoPermissao: "relDetalhamentoContrato", title: "Detalhamento Contrato", description: "Relatório detalhado contendo detalhamento de contratos vendidos", component: (<RelatorioDetalhamentoContrato></RelatorioDetalhamentoContrato>) },
        { codigo: "relPermissao", codigoPermissao: "relMidiaxVendas", title: "Mídia x Vendas", description: "Relatório detalhado de vendas por mídias utilizadas", component: (<RelatorioMidiaxVendas></RelatorioMidiaxVendas>) },
        { 
          codigo: "relPermissao", 
          codigoPermissao: "relVendasCliente", 
          title: "Vendas por Cliente", 
          description: "Relatório detalhado de vendas por cliente",
          component: (<RelatorioVendasByCliente></RelatorioVendasByCliente>) }
      ]
    },
    {
      tipo: "Estoque",
      relatorios: [
        {
          codigo: "relPermissao",
          codigoPermissao: "relMovimentoEstoque",
          title: "Movimento Estoque",
          description: "Relatório com detalhes do movimento dos produtos",
          component: [<RelatorioMovimentoEstoque></RelatorioMovimentoEstoque>]
        },
        {
          codigo: "relPermissao",
          codigoPermissao: "relSaldoEstoque",
          title: "Saldo Estoque",
          description: "Relatório com saldo atual dos produtos",
          component: [<RelatorioSaldoEstoque></RelatorioSaldoEstoque>]
        },
      ]
    },
    {
      tipo: "Outros",
      relatorios: [
        { codigo: "relPermissao", codigoPermissao: "relDemonstrativoAnual", title: "Demonstrativo Anual", description: "Relatório detalhado contendo dados de faturamento anual", component: (<RelatorioDemonstrativoAnual></RelatorioDemonstrativoAnual>) },
        { codigo: "relPermissao", codigoPermissao: "relTelegramaRecebiveis", title: "Telegrama Recebíveis", description: "Relatório detalhado contendo dados de recebimento", component: (<RelatorioTelegramaRecebiveis></RelatorioTelegramaRecebiveis>) },
      ]
    },
  ];

  const [relatorio, set_relatorio] = useState(null);

  const handleRelatorio = (item) => {
    set_relatorio(item.component);
  }

  const [relatoriosPermitidos, set_relatoriosPermitidos] = useState([])

  const loadRelatoriosPermitidos = () => {
    if (session.tipoPerfil == 0){
      set_relatoriosPermitidos(list_relatorios);
      return;
    }
    UseGetApiSimple("usuarios/getpermissoes/" + session.estabelecimentoId + "/" + session.id, "").then(result => {      
      if (result.status != 200){ 
        // INCLUIR MENSAGEM DE ERRO
        return;
      }
      let _relatoriosPermitidos = [];

      list_relatorios.map((m) => {
        let _relatorios = [];
        m.relatorios.map((n) => {
          if (result.data.filter(f => f.path == n.codigoPermissao && f.liberado).length > 0)
            _relatorios.push(n);
        })
        if (_relatorios.length > 0)
          _relatoriosPermitidos.push({
            tipo: m.tipo,
            relatorios: _relatorios
          });
      })

      set_relatoriosPermitidos(_relatoriosPermitidos);
    });    
  }

  useEffect(() => {
    loadRelatoriosPermitidos();
  }, []);

  return (
    <>
      {
        relatorio == null &&
        <div className="content">
          {relatoriosPermitidos.map((m, key) => (
            <div key={key} className="mt-4">
              <div className="subTitulo" style={{ marginTop: '20px', marginBottom: '0px' }}>
                <h6>{m.tipo}</h6>
              </div>
              <GridContainer>
                {m.relatorios.map((n, key2) => (
                  <GridItem key={key2} lg="4" md="6" sm="12">
                    <Card>
                      <CardBody className="rel-card-body">
                        <h5><strong>{n.title}</strong></h5>
                        {n.description}
                      </CardBody>
                      <CardFooter className="text-right">
                        <Button color="info" onClick={() => handleRelatorio(n)} className="btn-mobile">Visualizar Relatório</Button>
                      </CardFooter>
                    </Card>
                  </GridItem>
                ))}
              </GridContainer>
            </div>
          ))}
        </div>
      }
      {
        relatorio != null &&
        <>
          <GridContainer>
            <GridItem lg="12">
              <Button color="primary" onClick={() => set_relatorio(null)} className="btn-mobile">Voltar</Button>
            </GridItem>
          </GridContainer>
          {relatorio}
        </>
      }
    </>
  );
}